// extracted by mini-css-extract-plugin
module.exports = {"layout_container":"r9Lo_i","has_top_padding":"J3n0v2","main":"uW6aTe","has_x_padding":"lzSNx3","footer":"BNvqJ5"};